import { Link, LinkProps } from 'react-router';
import { forwardRef } from 'react';
import useInventoryUrlWithFilters from '../hooks/use-inventory-url-with-filters';

/**
 * Wrapper around the Link component that links to the inventory page while syncing the URL to
 * the filters stored in session storage.
 */
const LinkWithInventoryFilters = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, to, ...props }: LinkProps, ref) => {
    const toWithFilters = useInventoryUrlWithFilters(to.toString());
    return (
      <Link ref={ref} to={toWithFilters} reloadDocument={true} {...props}>
        {children}
      </Link>
    );
  }
);

LinkWithInventoryFilters.displayName = 'LinkWithInventoryFilters';

export default LinkWithInventoryFilters;
